<template>
  <div>
    <RefundDialog v-if="isModalOpen('refund-dialog')" />
    <CalendarSyncDialog v-if="isModalOpen('calendar-sync-dialog')" />
    <UpgradeModal v-if="isModalOpen('upgrade-modal')" />
    <InvoiceCancelDialog v-if="isModalOpen('invoice-cancel-dialog')"/>
    <SaleCancelDialog v-if="isModalOpen('sale-cancel-dialog')"/>
    <QrDialog v-if="isModalOpen('qr-dialog')"/>
    <ServiceScraperDialog v-if="isModalOpen('service-scraper-dialog')"/>
    <ImportProductsModal v-if="isModalOpen('import-products-modal')"/>
    <EditQuickActionsModal v-if="isModalOpen('edit-quick-actions-modal')"/>
    <EditItemModal v-if="isModalOpen('edit-item-modal')"/>
    <GenericUpsellDialog v-if="isModalOpen('generic-upsell-dialog')"/>
    <IframeModal v-if="isModalOpen('iframe-modal')"/>
    <AddTaxModal v-if="isModalOpen('add-tax-modal')"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CommonModals',
  components: {
    InvoiceCancelDialog: () => import('@/modules/modals/components/InvoiceCancelDialog.vue'),
    RefundDialog: () => import('@/modules/modals/components/RefundDialog.vue'),
    CalendarSyncDialog: () => import('@/modules/modals/components/CalendarSyncDialog.vue'),
    UpgradeModal: () => import('@/modules/modals/components/UpgradeModal.vue'),
    SaleCancelDialog: () => import('@/modules/modals/components/SaleCancelDialog.vue'),
    QrDialog: () => import('@/modules/modals/components/QrDialog.vue'),
    ServiceScraperDialog: () => import('@/modules/serviceScraper/components/ServiceScraperDialog.vue'),
    ImportProductsModal: () => import('@/modules/products/components/modals/ImportProductsModal.vue'),
    EditQuickActionsModal: () => import('@/modules/modals/components/EditQuickActionsModal.vue'),
    EditItemModal: () => import('@/modules/payments/components/modals/EditItemModal.vue'),
    GenericUpsellDialog: () => import('@/modules/common/components/GenericUpsell/GenericUpsellDialog.vue'),
    IframeModal: () => import('@/modules/modals/components/IframeModal.vue'),
    AddTaxModal: () => import('@/modules/payments/components/taxes/modals/AddTaxModal.vue'),
  },
  computed: {
    ...mapGetters('ModalStore', ['isModalOpen']),
  },
};
</script>
